import styled from 'styled-components'

export const TableWrapper = styled.div`
  padding: 10px 0px 0px 0px;
`
